/*
 * ⚠️ WARNING!!! ⚠️
 *
 * Do not use any react-router/remix hooks in this file. Because it will prevent
 * webflow being able to render this component since webflow does not use react-router
 * or remix.
 *
 * Instead use the ReactRouterStubsContext
 */

import * as Radix from "@radix-ui/themes";
import { Vivid } from "@vendrinc/frontend-ts";
import * as React from "react";
import styles from "./SaasHeader.module.css";
import { MobileMenuContext } from "~/contexts/mobileMenuContext";
import { ReactRouterStubsContext } from "~/contexts/reactRouterStubsContext";
import * as Analytics from "~/hooks/useAnalytics";
import { usePrefab } from "~/hooks/usePrefab";
import * as paths from "~/paths";

export const SaasHeader = () => {
  const prefab = usePrefab();
  const { location } = React.useContext(ReactRouterStubsContext);

  const { isMobileMenuOpen } = React.useContext(MobileMenuContext);

  if (isMobileMenuOpen) {
    return null;
  }

  const isPricingApiBannerEnabled =
    prefab.loading === false && prefab.isEnabled("pricing-api-homepage");
  const isOnPricingApiPage = location.pathname === paths.routes.pricingApi();

  return (
    <Radix.Flex direction="column" gap="0">
      {isPricingApiBannerEnabled && !isOnPricingApiPage ? (
        <PricingApiBanner />
      ) : (
        <ChromeExtensionBanner />
      )}
    </Radix.Flex>
  );
};

const ChromeExtensionBanner = () => {
  const stubs = React.useContext(ReactRouterStubsContext);
  const { trackLink } = Analytics.useAnalytics();

  return (
    <div className={styles.banner}>
      <Vivid.Heading node="h3" className={styles.bannerText}>
        Want instant access to real pricing data for 20k software products?
      </Vivid.Heading>
      <stubs.Link
        onClick={() => {
          trackLink({
            element_text: "Get Free Chrome Extension",
            element_location: "SaaS Header - Chrome Extension",
          });
        }}
        to="https://chromewebstore.google.com/detail/vendr/kghlccelgdbjoadlfnoajfeljdcefnmi"
        prefetch="intent"
        reloadDocument={true}
      >
        <Vivid.Button
          size="compact"
          buttonStyle="secondary"
          className={styles.bannerButton}
        >
          Get Free Chrome Extension
        </Vivid.Button>
      </stubs.Link>
    </div>
  );
};

const PricingApiBanner = () => {
  const stubs = React.useContext(ReactRouterStubsContext);
  const { trackLink } = Analytics.useAnalytics();

  return (
    <div className={styles.banner}>
      <Vivid.Heading node="h3" className={styles.bannerText}>
        Live price estimates, embedded in your product
      </Vivid.Heading>
      <stubs.Link
        onClick={() => {
          trackLink({
            element_text: "Learn more",
            element_location: "SaaS Header - Pricing API",
          });
        }}
        to={paths.routes.pricingApi()}
        prefetch="intent"
        reloadDocument={true}
      >
        <Vivid.Button
          size="compact"
          buttonStyle="secondary"
          className={styles.bannerButton}
        >
          Learn more
        </Vivid.Button>
      </stubs.Link>
    </div>
  );
};
